module.exports = __webpack_public_path__ + "img/glove.b7e0add1.svg";